export default __webpack_public_path__ + "static/media/coinbaseWalletIcon.2751f57b.png";